@use "../../../../../styles/Colors.scss" as Colors;
@use "../../../../../styles/Constants.scss" as Constants;
@use "../../../../../components/Table/styles.module.scss" as Table;

$var-search-top-offset: 98px;

.job-tracking {
	&__no-billing-code {
		color: Colors.$col-greyFontLight;
		font-style: italic;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
	}

	&__empty-cell {
		color: Colors.$col-greyFontLight;

		&--right-aligned {
			display: flex;
			justify-content: flex-end;
			width: 100%;
			padding-right: Constants.$val-spacing-xs;
		}
	}
}

.job-tracking-table {
	height: calc(
		100vh - Table.$var-company-header-height - Table.$var-breadcrumbs-header-height -
			Table.$var-tabs-navigation-height - Table.$var-table-action-header-height - Table.$var-table-footer-height -
			4 * Constants.$val-spacing-xl - 6 * Constants.$val-spacing-m
	) !important;
}

.no-template-container {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	height: max-content;
	width: 100%;
	height: 100%;
	background-color: white;
}

.name-cell {
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: flex-start;
}

.crew-type {
	display: flex;
	justify-content: flex-start;
	flex-direction: column;
	overflow-x: hidden;
}

.header-button {
	color: Colors.$col-design-blue500;
	&:hover {
		cursor: pointer;
	}
}

.info-cell {
	display: flex;
	justify-content: center;
	align-items: flex-start;
	overflow-x: hidden;
	gap: Constants.$val-spacing-xxs;
	padding: Constants.$val-spacing-xs;

	&--right-aligned {
		display: flex;
		flex-direction: row;
		justify-content: flex-end;
		align-items: flex-end;
		width: 100%;
		padding-right: Constants.$val-spacing-xs;
		padding-bottom: Constants.$val-spacing-xxs;
	}

	&--left-aligned {
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		align-items: flex-end;
		width: 100%;
		padding-left: Constants.$val-spacing-xs;
		padding-bottom: Constants.$val-spacing-xxs;
	}
}

.dollar-cell {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	width: 100%;
	white-space: nowrap;
	min-width: 0;
}

.material-header {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	text-align: center;
	line-height: 1.2;
	padding: 4px 6px;
}

.material-header__name {
	font-weight: 500;
}

.material-header__groups {
	font-size: 12px;
}

.material-header__description {
	font-size: 12px;
}

.job-tracking {
	&__side-drawer {
		display: flex;
		flex-direction: column;
		gap: Constants.$val-spacing-m;
		padding: Constants.$val-spacing-m 0;
		box-sizing: border-box;
	}

	&__side-drawer__row {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		padding-right: Constants.$val-spacing-m;
		padding-bottom: Constants.$val-spacing-s;
		border-bottom: 1px solid Colors.$col-lighterGrey;
	}

	&__side-drawer__code {
		display: flex;
		align-items: center;
		margin: 0 Constants.$val-spacing-xs;
		font-size: Constants.$val-fontSizeRegular;
		font-weight: bold;
	}

	&__side-drawer__amount {
		display: flex;
		align-items: center;
		justify-content: flex-end;
		padding: 0 Constants.$val-spacing-m;
		font-size: Constants.$val-fontSizeRegular;
		color: Colors.$col-blackDark;
		min-width: 0;
	}
}

.table-filter {
	display: flex;
	flex-direction: row;
	align-items: center;
	width: 100%;
	padding: Constants.$val-spacing-s Constants.$val-spacing-m;
	position: sticky;
	top: $var-search-top-offset;
	z-index: 6;
}

.table-filter__left {
	display: flex;
	align-items: center;
	gap: 8px;
}

.table-filter__column-filters {
	display: flex;
	align-items: center;
	gap: 8px;
	margin-left: 4px;
}

.table-filter__right {
	display: flex;
	align-items: center;
	margin-left: auto;
}

.search-bar {
	width: 300px;
	margin-right: 8px;
}

.search-icon {
	color: Colors.$col-design-grey500;
	font-size: Constants.$val-icon16;
	margin-right: Constants.$val-spacing-s;
}

.table-container {
	border: 1px solid Colors.$col-design-grey14;
	padding: Constants.$val-spacing-s;
	background-color: white;
	height: calc(
		100vh - Table.$var-company-header-height - Table.$var-breadcrumbs-header-height -
			Table.$var-tabs-navigation-height - Table.$var-table-header-height - Constants.$val-spacing-xl
	);
}

.white-background-cell {
	height: 100%;
	width: 100%;
	background-color: white;
}

.grey-background-cell {
	height: 100%;
	width: 100%;
	background-color: Colors.$col-design-gray50;
}

.white-background-cell,
.grey-background-cell {
	display: flex;
	align-items: center; // keep vertical centering of the text
	width: 100%;
	height: 100%;
	box-sizing: border-box;
}

.grey-text {
	color: Colors.$col-design-grey500;
}

.totals-value {
	display: flex;
	flex-direction: row;
	gap: Constants.$val-spacing-s;
}

.info-icon {
	color: Colors.$col-design-blue500;
}

.material-source {
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: Constants.$val-spacing-s;
}

.material-details-header {
	display: flex;
	flex-direction: column;
	align-items: center;
}

.totals-value-cell {
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	align-items: flex-end;
	padding: Constants.$val-spacing-xs;
}

.totals-message {
	display: flex;
	flex-direction: row;
	align-items: center;
	padding-left: Constants.$val-spacing-s;
	color: Colors.$col-design-gray700;
	font-family: "Roboto", sans-serif;
	font-style: italic;
}

.totals-tooltip-popover {
	width: 320px !important;
	max-width: 320px !important;

	:global(.popover-content) {
		width: 100%;
		box-sizing: border-box;
	}

	&--billing-code {
		width: max-content !important;
		max-width: 900px !important;
	}
}

.totals-tooltip {
	width: 100%;
	max-width: 100%;
	text-align: center;
	white-space: normal;
	overflow-wrap: break-word;
	word-break: normal;
	line-height: Constants.$val-lineHeightSmall;
}

.totals-tooltip__title {
	display: block;
	font-weight: 700 !important;
	font-size: Constants.$val-fontSizeSmall;
	text-align: center;
	margin-bottom: Constants.$val-spacing-xxs;
}

.totals-tooltip__message {
	display: block;
	font-weight: 400;
	font-size: Constants.$val-fontSizeSmall;
	text-align: center;
	white-space: normal;

	&--billing-code {
		white-space: nowrap;
	}
}

.text-value-cell {
	padding: 0 Constants.$val-spacing-xs;
	display: flex;
	align-items: center;
}

.highlighted-cell {
	background-color: Colors.$col-design-blue100 !important;

	.white-background-cell,
	.grey-background-cell {
		background-color: transparent !important;
	}
}

.billing-code-name {
	display: inline-flex;
	align-items: center;
	gap: 4px;
}

.billing-code-archive-icon {
	font-size: 12px;
}
.info-cell,
.info-cell--left-aligned,
.info-cell--right-aligned,
.dollar-cell,
.white-background-cell,
.grey-background-cell,
.job-tracking__empty-cell,
.job-tracking__empty-cell--left-aligned,
.job-tracking__empty-cell--right-aligned {
	height: 100%;
	min-height: 0;
	align-items: center;
	box-sizing: border-box;
}

.icon {
	font-size: Constants.$val-icon20;
	margin-bottom: Constants.$val-spacing-m;
}

.info-margin {
	margin-bottom: Constants.$val-spacing-m;
}